import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './components/main/main.component';
import { ImpairedCatalogItemsRoutes } from './modules/models/routes';

export const routes: Routes = [
  {
    path: `:id/${ImpairedCatalogItemsRoutes.Item}/:itemId`,
    loadChildren: () => import('./modules/item-card/item-card.module').then(x => x.ItemCardModule)
  },
  {
    path: ':id',
    loadChildren: () => import('./modules/main/data-set-items.module').then(x => x.DataSetItemsModule)
  },
  {
    path: '',
    component: MainComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RoutingModule {}
